import { useModal } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import { CustomerOnboardingContent, type CloseGuard } from "../ui/customer-onboarding.content";

interface UseCustomerOnboardingModalOptions {
  providerId?: number;
  /** Called once the wizard is dismissed, so the list behind it can refetch. */
  onFinished?: () => void;
}

export function useCustomerOnboardingModal(options?: UseCustomerOnboardingModalOptions) {
  const { openModal, closeModal } = useModal();
  const t = useT();

  const open = () => {
    // Guard and id are filled after openModal; both are read later, from a user gesture.
    const closeGuardRef: CloseGuard = { current: () => true };
    const idRef = { current: "" };

    const id = openModal({
      size: "custom",
      width: { md: 1200 },
      height: { md: 800 },
      title: (
        <span className="text-xl font-bold leading-6 tracking-[-0.01em] text-text-body">
          {t(Namespace.Customers, "onboarding.title")}
        </span>
      ),
      bodyClassName: "!p-0 flex flex-col flex-1 min-h-0 overflow-hidden",
      // The shell's cross, Escape and backdrop click all land here.
      onRequestClose: () => closeGuardRef.current(),
      body: (
        <CustomerOnboardingContent
          providerId={options?.providerId}
          closeGuardRef={closeGuardRef}
          onFinished={options?.onFinished}
          onClose={() => closeModal(idRef.current)}
        />
      ),
    });

    idRef.current = id;
  };

  return { open };
}
